//Importaciones
import React, { useContext, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isNullUndefined } from '../../../../../../common/Helpers';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { useDispatch, useSelector } from 'react-redux';
import { action_setCompareContracts_ChartData_Structure, action_setCompareContracts_FireGetData, action_setCompareContracts_Pilar, action_setCompareContracts_SegmentList, action_setCompareContracts_SegmentSelected } from '../../../../../../reducers/actions/KPI/compareContractsActions';
import { useSearch } from '../../../../../../hooks/component/useOfContractCompare';
import MainAppContext from '../../../../../../MainAppContext';


function CONSOLIDATE_GROUP_LIST_TO_SELECT(props) {
    //Helpers
    const { t } = useTranslation();
    const dispatch = useDispatch();
	const contextSite = useContext(MainAppContext);

    const { 
      inputParam_HideHeader = false,
      inputParam_ComponentContent = null,
      inputParam_UseFake = false,
	  inputParam_BoardId = null,
    } = props;

    const { 
		_pilarSeleccionado: pilarSeleccionado,
		_contratosParaGrafico: selectedContracts,
		_segmentSelected: segmentSelected,
	} = useSelector((state) => state.compareContractsScope);

	const [grupos, setGrupos] = useState(inputParam_ComponentContent.items);
	const [defaultSelectedGroupsBinded, setDefaultSelectedGroupsBinded] = useState(false);
	const [defaultSelectedFiltersBinded, setDefaultSelectedFiltersBinded] = useState(true);

	const onSelectGroup = (group) => {
		dispatch(action_setCompareContracts_FireGetData(true))
		dispatch(action_setCompareContracts_Pilar(group))
		
		setDefaultSelectedFiltersBinded(false)

		dispatch(action_setCompareContracts_ChartData_Structure(null))//ojo
		dispatch(action_setCompareContracts_SegmentList(null))
		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: null, propertySegment: null}))
	}

	useEffect(() => {
        function doit() {
			setDefaultSelectedGroupsBinded(true);
			const defaulSelectedPilar = inputParam_ComponentContent.items.length > 0 ? inputParam_ComponentContent.items.find(x => x.selected === true) : null;
			dispatch(action_setCompareContracts_Pilar(defaulSelectedPilar))
		}
  
		if (defaultSelectedGroupsBinded === false &&
			!isNullUndefined(inputParam_ComponentContent) &&
			!isNullUndefined(inputParam_ComponentContent.items)) {
				doit()
		}
    }, [inputParam_ComponentContent, defaultSelectedGroupsBinded, setDefaultSelectedGroupsBinded]);



    const renderContent = () => {
      	return  <Row className='h-100 px-3'>
					{
						grupos && grupos.map(group => (
							<Col key={group.groupId} className='my-2'>
								<div className='p-0 m-0 cursor-pointer border' onClick={() => onSelectGroup(group)}>
									<Card.Body className='p-2' style={{
											backgroundColor: (!isNullUndefined(pilarSeleccionado) ? (pilarSeleccionado.scopeId === group.scopeId ? "grey" : "white") : "white"),
											color: (!isNullUndefined(pilarSeleccionado) ? (pilarSeleccionado.scopeId === group.scopeId ? "white" : "black") : "black")
										}}>
											<span>{group.name}</span>
									</Card.Body>
								</div>
							</Col>
						))
					}
				</Row>
    }

	useSearch(defaultSelectedFiltersBinded, setDefaultSelectedFiltersBinded, contextSite, selectedContracts, inputParam_BoardId, pilarSeleccionado, segmentSelected)

    //Render de componente.
    return (
		<>
			{
				!inputParam_UseFake &&
				<Card className='h-100'>
					{
						!inputParam_HideHeader &&
						<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
									<b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-group_list_to_select')) : t('data-lang-boxname-group_list_to_select')}</b>
									<div className='toolbar d-flex'>

									</div>
								</Card.Title>
						</Card.Header>
					}
					<Card.Body className='h-100 p-0 m-0'>
						{ renderContent() }
					</Card.Body>
				</Card>
			}
			{ inputParam_UseFake && renderContent() }
		</>
    );
}

CONSOLIDATE_GROUP_LIST_TO_SELECT.propTypes = {
	inputParam_HideHeader: PropTypes.bool.isRequired,
	inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default CONSOLIDATE_GROUP_LIST_TO_SELECT;